const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');
const { transformEnumToOptions } = require('@/tools');

module.exports = () => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      hidden: true,
      options: transformEnumToOptions({ labels: CHANNEL_INTERFACE_TEXT, values: CHANNEL_INTERFACE_TYPE }),
      value: '',
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'input',
      hidden: true,
      value: '',
    },
    app_id: {
      label: '应用APPID',
      type: 'input',
      hidden: true,
      value: '',
    },
    rebate: {
      label: '返点',
      type: 'input-number',
      props: {
        min: 0,
        precision: 4,
      },
      value: 0,
    },
  };
};
